module.exports = __webpack_public_path__ + "static/media/Rove - Top Right Details - 22 March 2023.c51d60f4.mp4";